import { FunctionalityService } from "../../api/functionality-service";
import { EOSService } from "../../api/eos-service";
import Result from "../../model/result";

const state = {
};

const getters = {};

const actions = {
    async GetEosMonthlyYearsList() {
        return await EOSService.makeRequest(FunctionalityService.GetEosMonthlyYearsList())
    },
    async GetEosMonthList(state, { params }) {
        return await FunctionalityService.GetEosMonthList(params).then((response) => {
            var data = response.data
            if (data.ResponseResultType === 1) {
                let res = data.Values
                let list = []
                res.forEach(item => {
                    list.push(item.MMonth)
                });
                return Result.success(list)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async GetPersonMonthWork(state, { params }) {
        if (!params.get('perno')) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        }

        return await EOSService.makeRequest(FunctionalityService.GetPersonMonthWork(params))
    },
    async GetPersonelMonthWork(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('perno', perno);

        return await EOSService.makeRequest(FunctionalityService.GetPersonelMonthWork(params))
    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}